import { Navigate } from "react-router-dom";
import { COMMITTEES_ACTIVE_PATH } from "./constants";

export default function CommitteesIndexPage() {
  return <Navigate to={COMMITTEES_ACTIVE_PATH} replace />;
}
